import axiosCommon from '@/axios-common/axios-common'

export default {
    name: 'Login',
    data: function () {
        return {
            username: '',
            password: ''
        }
    },
    methods: {
        signIn() {

            let vm = this

            if (vm.username.trim() === '') {
                vm.$snotify.error('Username is required', 'Error')
                return
            }

            if (vm.password.trim() === '') {
                vm.$snotify.error('Password is required', 'Error')
                return
            }

            axiosCommon.post('o/login', {
                "username": vm.username,
                "password": vm.password
            })
            .then(function (res) {
                vm.$snotify.success('Login successful', 'Success')
                localStorage.setItem('token',res.headers.authorization)
                vm.$router.push({name:'customFileUpload'})
            }).catch(function (err) {
                vm.$snotify.error('Login failed', 'Error')
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/login/login.js